import React from 'react';
import { Form, Button, Card, Row, Col } from 'react-bootstrap';
import { Globe, Clock, Bell, Lock, Key, Shield, Trash2, Save } from 'lucide-react';
import './Configuracion.css';

const Configuracion = () => {
  return (
    <div className="configuracion-container">
      <div className="page-header mb-4">
        <div>
          <h2 className="page-title">Configuración</h2>
          <p className="page-subtitle text-muted">Personaliza tu experiencia en SatGO</p>
        </div>
      </div>

      <Row className="g-4">
        <Col lg={6}>
          <Card className="config-card border-0 shadow-sm">
            <Card.Header className="card-header-modern">
              <div className="d-flex align-items-center">
                <div className="header-icon-wrapper me-3">
                  <Globe size={20} />
                </div>
                <h5 className="mb-0">Preferencias de Cuenta</h5>
              </div>
            </Card.Header>
            <Card.Body className="p-4">
              <Form>
                <Form.Group className="mb-4">
                  <Form.Label className="form-label-modern">
                    <Clock size={16} className="me-2" />
                    Zona Horaria
                  </Form.Label>
                  <Form.Select defaultValue="America/Mexico_City" className="form-control-modern">
                    <option value="America/Mexico_City">Ciudad de México (GMT-6)</option>
                    <option value="America/Tijuana">Tijuana (GMT-8)</option>
                    <option value="America/Monterrey">Monterrey (GMT-6)</option>
                    <option value="America/Cancun">Cancún (GMT-5)</option>
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-4">
                  <div className="switch-wrapper">
                    <div className="d-flex align-items-center">
                      <Bell size={16} className="me-2 text-muted" />
                      <div className="flex-grow-1">
                        <div className="switch-label">Notificaciones por Email</div>
                        <small className="text-muted">Recibe actualizaciones importantes</small>
                      </div>
                      <Form.Check
                        type="switch"
                        id="notifications-switch"
                        className="custom-switch"
                        defaultChecked
                      />
                    </div>
                  </div>
                </Form.Group>

                <Button className="btn-save w-100">
                  <Save size={18} className="me-2" />
                  Guardar Cambios
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={6}>
          <Card className="config-card border-0 shadow-sm">
            <Card.Header className="card-header-modern">
              <div className="d-flex align-items-center">
                <div className="header-icon-wrapper me-3">
                  <Shield size={20} />
                </div>
                <h5 className="mb-0">Seguridad</h5>
              </div>
            </Card.Header>
            <Card.Body className="p-4">
              <div className="security-option mb-3">
                <div className="d-flex align-items-start">
                  <div className="security-icon me-3">
                    <Key size={20} />
                  </div>
                  <div className="flex-grow-1">
                    <h6 className="mb-1">Cambiar Contraseña</h6>
                    <p className="text-muted mb-2 small">Actualiza tu contraseña regularmente</p>
                    <Button variant="outline-primary" size="sm" className="security-btn">
                      Cambiar
                    </Button>
                  </div>
                </div>
              </div>

              <div className="divider my-4"></div>

              <div className="security-option mb-3">
                <div className="d-flex align-items-start">
                  <div className="security-icon me-3">
                    <Lock size={20} />
                  </div>
                  <div className="flex-grow-1">
                    <h6 className="mb-1">Autenticación de Dos Factores</h6>
                    <p className="text-muted mb-2 small">Añade una capa extra de seguridad</p>
                    <Button variant="outline-primary" size="sm" className="security-btn">
                      Configurar 2FA
                    </Button>
                  </div>
                </div>
              </div>

              <div className="divider my-4"></div>

              <div className="security-option danger-zone">
                <div className="d-flex align-items-start">
                  <div className="security-icon danger me-3">
                    <Trash2 size={20} />
                  </div>
                  <div className="flex-grow-1">
                    <h6 className="mb-1 text-danger">Eliminar Cuenta</h6>
                    <p className="text-muted mb-2 small">Esta acción no se puede deshacer</p>
                    <Button variant="outline-danger" size="sm" className="security-btn-danger">
                      Eliminar Cuenta
                    </Button>
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Configuracion;
